export const CEMENTERY_LAT = 46.305119527491414;
export const CEMENTERY_LNG = 25.299652218818668;
export const MAP_ZOOM = 18;
export const TRUNCATE = 256;
export const MINIMUM_YEAR_THAT_CAN_BE_ENTERED = 100;
